/**
 * DO NOT EDIT - THIS CODE WAS GENERATED FROM "backend/shared/utils/clientGenerator.ts".
 *
 * To update types or enums, please make changes in "backend/shared/data/types/config",
 * Then run `make generate-api-client` to update.
 */

/* tslint:disable */
/* eslint-disable */
/* prettier-ignore */
export const UnknownServerErrorAppCode = "UnknownServerError"
export declare abstract class ApiErrorBase<TAppCode extends string = string> extends Error {
    appCode: TAppCode;
    developerMessage?: string | undefined;
    constructor(appCode: TAppCode, message: string, developerMessage?: string | undefined);
}
export interface IErrorRegistration<TError extends {
    appCode: string;
}, TData> {
    appCode: string;
    status: number;
    toJson: (e: TError) => TData;
    fromJson: (d: TData) => TError;
}
export declare class ApiError {
    static errors: IErrorRegistration<any, any>[];
    static registerCore(): void;
    static isApiError(testError: any): testError is ApiErrorBase<any>;
    static register<TErrorConstructor extends new (...args: any[]) => {
        appCode: string;
        developerMessage?: string;
    }>(_error: TErrorConstructor, status: number): {
        transit<TKeys extends Exclude<keyof InstanceType<TErrorConstructor>, "developerMessage" | "appCode">>(...keys: TKeys[]): {
            recreate(fromJson: (d: Pick<InstanceType<TErrorConstructor>, TKeys>) => InstanceType<TErrorConstructor>): ClassDecorator;
        };
    };
    static createApiError(data: any): any;
}
export declare class UnknownServerError extends ApiErrorBase<typeof UnknownServerErrorAppCode> {
    data: any;
    constructor(data: any, developerMessage?: string);
}
export declare class UnauthorisedError extends ApiErrorBase<'UnauthorisedError'> {
    constructor(message: string, developerMessage?: string);
}
export declare class RequestEntityTooLargeError extends ApiErrorBase<'RequestEntityTooLargeError'> {
    expected: number;
    length: number;
    limit: number;
    constructor(message: string, expected: number, length: number, limit: number);
}
export declare class NotFoundError extends ApiErrorBase<'NotFoundError'> {
    constructor(message: string, developerMessage?: string);
}
export declare class BadRequestError extends ApiErrorBase<'BadRequestError'> {
    constructor(message: string, developerMessage?: string);
}
export declare class ForbiddenError extends ApiErrorBase<'ForbiddenError'> {
    constructor(message: string, developerMessage?: string);
}
export interface IValidationErrorMessages {
    developer: string;
    friendly?: string;
}
export interface IValidationErrorDetail {
    attribute?: string;
    path: string;
    value: any;
    messages: IValidationErrorMessages;
}
export declare class ValidationError extends ApiErrorBase<'ValidationError'> {
    errors: IValidationErrorDetail[];
    constructor(errors: IValidationErrorDetail[], developerMessage?: string);
}
export declare class ConfigurationError extends ApiErrorBase<'ConfigurationError'> {
    constructor(message: string, developerMessage?: string);
}
export declare class ConflictError extends ApiErrorBase<'ConflictError'> {
    constructor(message: string, developerMessage?: string);
}
export declare class ArgumentError extends ApiErrorBase<'ArgumentError'> {
    parameter: string;
    constructor(parameter: string, developerMessage?: string);
}
export declare type OrbitError = UnknownServerError | UnauthorisedError | RequestEntityTooLargeError | NotFoundError | BadRequestError | ForbiddenError | ValidationError | ConfigurationError | ConflictError | ArgumentError;
/**
 * Defines the supported device types, which correlates with device drivers
 *
 * This interface was referenced by `BEEConfiguration`'s JSON-Schema
 * via the `definition` "device_type".
 */
export enum DeviceType {
  IEM2055 = "iem2055",
  IEM2155 = "iem2155",
  IEM3100 = "iem3100",
  SCHNEIDER_IEM3455 = "schneider_iem3455",
  EASTRON_SDM630MCT_MV = "eastron_sdm630mct_mv",
  EASTRON_SDM630MCT_4L = "eastron_sdm630mct_4L",
  EASTRON_SDM630MCT_MID = "eastron_sdm630mct_mid",
  SHARKY = "sharky",
  WRF04 = "wrf04",
  WRF06 = "wrf06",
  RELAY = "relay",
  MASTERTHERM = "mastertherm",
  REGIN = "regin",
  NOVOS3 = "novos3",
  NTCTF25 = "ntctf25",
  ade7816 = "ade7816",
  ISOIL_IFXM4E3 = "isoil_ifxm4e3"
}
export enum Amperage {
  inlineMeter45amp = 45,
  inlineMeter63amp = 63,
}
/**
 * The variation of the rule to use
 */
export enum RuleVariant {
  IMMERSION_HEATER = "immersion_heater",
  COMBI_BOILER = "combi_boiler",
  SYSTEM_BOILER = "system_boiler",
  VAILANT = "vailant"
}
/**
 * The action type that will be performed
 */
export enum RuleActionType {
  CONTROL = "control",
  MONITORING = "monitoring"
}
/**
 * Categorises rules into functional groups
 */
export enum RuleCategory {
  TEMPERATURE = "temperature",
  THERMOSTAT = "thermostat",
  DIAL = "dial",
  ELECTRICITY = "electricity",
  HEATING = "heating",
  HOT_WATER = "hot_water",
  HEAT_FLOW = "heat_flow"
}
export interface InlineMeter<T extends DeviceType, A extends Amperage, M> extends DeviceInfoBase<T> {
  params: {
    variant?: RuleVariant;
    action_type: RuleActionType;
    category: RuleCategory;
    address: M;
    channel?: any; // To be fixed - https://sero-digital.atlassian.net/browse/IES-1384
    meter_amperage: A;
    circuit_label: string;
    circuit_type: CircuitType.REGULATED | CircuitType.UNREGULATED;
  };
}
export interface DeviceInfoBase<T extends DeviceType> {
  deviceType: T | DeviceType;
  params: { [x: string]: any; category: RuleCategory; action_type: RuleActionType; variant?: RuleVariant };
}
/**
 * The shape of the circuit type object for device rules configuration metadata
 *
 * This interface was referenced by `BEEConfiguration`'s JSON-Schema
 * via the `definition` "rule_metadata_circuit_type".
 */
export enum CircuitType {
  REGULATED = "Regulated",
  UNREGULATED = "Unregulated",
  WHOLE_HOME = "Whole home",
  MAIN_INCOMING_SUPPLY = "Main incoming supply"
}
export interface CTMeter<T extends DeviceType> extends DeviceInfoBase<T> {
  params: {
    variant?: RuleVariant;
    action_type: RuleActionType;
    category: RuleCategory;
    address: number;
    channel?: any; // To be fixed - https://sero-digital.atlassian.net/browse/IES-1384
    clamp_1_circuit_label: string;
    clamp_1_circuit_type: CircuitType;
    clamp_2_circuit_label: string;
    clamp_2_circuit_type: CircuitType;
    clamp_3_circuit_label: string;
    clamp_3_circuit_type: CircuitType;
    non_metered_circuits: string;
  };
}
/**
 * The circuit the heat flow meter
 */
export enum HeatFlowMeterCircuit {
  HEATING = "heating",
  HOT_WATER = "hot_water"
}
export interface HeatFlowMeter<T extends DeviceType> extends DeviceInfoBase<T> {
  params: {
    variant?: RuleVariant;
    action_type: RuleActionType;
    category: RuleCategory;
    address: number;
    channel?: any; // To be fixed - https://sero-digital.atlassian.net/browse/IES-1384
    heat_flow_meter_circuit: HeatFlowMeterCircuit;
    install_location: string;
  };
}
/**
 * Specifies the name of the heating zone
 *
 * This interface was referenced by `BEEConfiguration`'s JSON-Schema
 * via the `definition` "zone_id".
 */
export enum HeatingZoneID {
  WHOLE_HOME = "whole_home",
  LIVING_ROOM = "living_room",
  KITCHEN = "kitchen",
  GROUND_FLOOR = "ground_floor",
  FIRST_FLOOR = "first_floor",
  SECOND_FLOOR = "second_floor",
  THIRD_FLOOR = "third_floor",
  BEDROOM_1 = "bedroom_1",
  BEDROOM_2 = "bedroom_2",
  HOT_WATER = "hot_water",
  BATHROOM = "bathroom"
}
/**
 * Location IDs which excludes whole_home
 *
 * This interface was referenced by `BEEConfiguration`'s JSON-Schema
 * via the `definition` "physical_location_id".
 */
export enum PhysicalLocationID {
  LIVING_ROOM = "living_room",
  KITCHEN = "kitchen",
  GROUND_FLOOR = "ground_floor",
  FIRST_FLOOR = "first_floor",
  SECOND_FLOOR = "second_floor",
  THIRD_FLOOR = "third_floor",
  BEDROOM_1 = "bedroom_1",
  BEDROOM_2 = "bedroom_2",
  BATHROOM = "bathroom"
}
/**
 * The heating system to control within the heat pump
 */
export enum HeatPumpHeatingControl {
  HC1 = "HC1",
  HC2 = "HC2"
}
export interface RoomSensor<T extends DeviceType> extends DeviceInfoBase<T> {
  params: {
    variant?: RuleVariant;
    action_type: RuleActionType;
    category: RuleCategory;
    address: number;
    channel?: any; // To be fixed - https://sero-digital.atlassian.net/browse/IES-1384
    zone_id: HeatingZoneID;
    dip_switch_position?: number;
    install_location: PhysicalLocationID;
    heat_pump_heating_control?: HeatPumpHeatingControl;
    primary_zone_temperature_sensor?: string | number;
  };
}
/**
 * The shape of the heating system object for device rules configuration metadata
 *
 * This interface was referenced by `BEEConfiguration`'s JSON-Schema
 * via the `definition` "rule_metadata_heating_system".
 */
export enum HeatingSystem {
  NOT_CONTROLLED_BY_IES = "Heating not controlled by the IES",
  COMBI = "Combi boiler",
  HOTWATER_CYLINDER = "Boiler with hot water cylinder",
  MASTERTHERM = "MasterTherm heat pump"
}
export interface HeatingControl<T extends DeviceType> extends DeviceInfoBase<T> {
  params: {
    variant?: RuleVariant;
    action_type: RuleActionType;
    category: RuleCategory;
    heating_system?: HeatingSystem;
    heat_pump_heating_control?: HeatPumpHeatingControl;
    address: number;
    zone_id: HeatingZoneID;
  };
}
/**
 * The different types of hot water sources
 *
 * This interface was referenced by `BEEConfiguration`'s JSON-Schema
 * via the `definition` "hot_water_source_type".
 */
export enum HotWaterSourceType {
  PRIMARY = "primary",
  SECONDARY = "secondary"
}
/**
 * Definitive list of hot water sources
 *
 * This interface was referenced by `BEEConfiguration`'s JSON-Schema
 * via the `definition` "hot_water_source".
 */
export enum HotWaterSource {
  SYSTEM_BOILER = "System boiler",
  HEAT_PUMP = "Heat pump",
  IMMERSION_HEATER = "Immersion heater",
  COMBI_BOILER = "Combi Boiler",
  OTHER = "Other"
}
export interface HotWaterSourceInput<T extends DeviceType> extends DeviceInfoBase<T> {
  params: {
    variant?: RuleVariant;
    action_type: RuleActionType;
    category: RuleCategory;
    address: number;
    hot_water_source_type: HotWaterSourceType;
    hot_water_source?: HotWaterSource;
  };
}
export interface RoomDial<T extends DeviceType> extends DeviceInfoBase<T> {
  params: {
    variant?: RuleVariant;
    action_type: RuleActionType;
    category: RuleCategory;
    address: number;
    channel?: any; // To be fixed - https://sero-digital.atlassian.net/browse/IES-1384
    zone_id: HeatingZoneID;
    install_location: PhysicalLocationID;
  };
}
/**
 * Defines the shape of a setpoint for a hot water schedule
 *
 * This interface was referenced by `BEEConfiguration`'s JSON-Schema
 * via the `definition` "hot_water_schedule_setpoint".
 */
export interface HotWaterScheduleSetpoint {
  time: string;
  hot_water_active: 0 | 1;
  /**
   * The time the user set the schedule for
   */
  user_time?: string;
}
/**
 * Defines the shape of a hot water schedule. A hot water schedule is made up of 7 days (Monday - Sunday) with a maximum of 6 setpoints for each day
 *
 * This interface was referenced by `BEEConfiguration`'s JSON-Schema
 * via the `definition` "hot_water_schedule".
 */
export interface HotWaterSchedule {
  zone_id: HeatingZoneID;
  setpoints: HotWaterScheduleSetpoint[];
}
export interface TemperatureSensor<T extends DeviceType> extends DeviceInfoBase<T> {
  params: {
    variant?: RuleVariant;
    action_type: RuleActionType;
    category: RuleCategory;
    address: number;
    channel?: any; // To be fixed - https://sero-digital.atlassian.net/browse/IES-1384
    zone_id: HeatingZoneID;
  };
}
/**
 * Defines the shape of a setpoint for a heating schedule
 *
 * This interface was referenced by `BEEConfiguration`'s JSON-Schema
 * via the `definition` "heating_schedule_setpoint".
 */
export interface HeatingScheduleSetpoint {
  time: string;
  temperature: number;
  /**
   * The time the user has set the schedule for
   */
  user_time?: string;
  type?: "start" | "end";
}
export declare type RouterId = OpaqueString<'RouterId'>;
export declare type OpaqueString<Key extends string> = string & {
    __opaque: Key;
};
export declare type DeviceId = OpaqueString<'DeviceId'>;
export interface IRegister {
  routerId: RouterId;
  deviceId: DeviceId;
  publicKey?: string;
  privateKey?: string;
}
export interface ICommission {
  [key: string]: any;
}
export declare type Uprn = OpaqueString<'Uprn'>;
export interface IPropertyAddress {
  addressEnteredManually: boolean;
  addressLine1: string;
  addressLine2?: string;
  addressLine3?: string;
  city: string;
  county?: string;
  country?: string;
  postcode: string;
  administrativeCounty?: string;
  buildingName?: string;
  buildingNumber?: string;
  deliveryPointSuffix?: string;
  departmentName?: string;
  dependantLocality?: string;
  dependantThoroughfare?: string;
  district?: string;
  doubleDependantLocality?: string;
  eastings?: number;
  latitude?: number;
  longitude?: number;
  northings?: number;
  organisationName?: string;
  poBox?: string;
  postalCounty?: string;
  postcodeInward?: string;
  postcodeOutward?: string;
  postcodeType?: string;
  premise?: string;
  suOrganisationIndicator?: string;
  subBuildingName?: string;
  thoroughfare?: string;
  traditionalCounty?: string;
  udprn?: number;
  umprn?: string;
  uprn?: string;
  ward?: string;
}
export enum Project {
  OptimisedRetrofit = 'Optimised Retrofit',
  Penderi = 'Penderi',
  EasternHigh = 'Eastern High',
  ParcEirin = 'Parc Eirin',
  CountyFlats = 'County Flats',
  Ladyhill = 'Ladyhill',
  Gwynfaen = 'Gwynfaen',
  OSBPilots = 'OSB Pilots',
  AddisonHouse = 'Addison House',
  CourtPlace = 'Court Place',
  Brookfield = 'Brookfield',
  SeroTesting = 'Sero Testing',
  MHG = 'MHG',
  SovereignSHDF = 'Sovereign SHDF',
  SpringGardens = 'Spring Gardens',
}
export enum BeeStatus {
  NotFound = 'NotFound', // not registered
  Offline = 'Offline', // registered but no activity within 12hrs
  Online = 'Online', // registered with activity within 12hrs
}
/**
 * The version of BEE hardware
 */
export enum BEEHardware {
  BEE1 = "bee1",
  BEE2 = "bee2",
  BEE3 = "bee3",
  HOST_MODE = "host_mode"
}
export enum BeeTag {
  TRUSTMARK = 'TRUSTMARK',
}
export declare type TrialId = OpaqueString<'TrialId'>;
export interface ITrial {
  id: TrialId;
  name: string;
  meterableUnitId: string;
  createdOn?: Date | string;
  createdBy?: string;
  updatedOn?: Date | string;
  updatedBy?: string;
}
export interface IBee {
  deviceId: DeviceId;
  routerId?: RouterId;
  uprn?: Uprn;
  physicalAddress?: IPropertyAddress;
  stickerImage?: string;
  plot?: string;
  project?: Project;
  currentAppVersion?: string;
  status?: BeeStatus;
  firmwareVersion?: string;
  arePeripheralsHealthy?: boolean;
  firmwareUpdateRequested?: Date;
  firmwareUpdateVersion?: string;
  currentFirmwareVersion?: string;
  isHealthy?: boolean;
  stateLastUpdated?: Date;
  inActiveTrialEvent?: boolean;
  isHeatSourceOn?: boolean;
  hardwareVersion?: BEEHardware;
  tags?: BeeTag[];
  trialId?: TrialId | null;
  trial?: ITrial;
  configProfileVersion?: string;
  beeMode?: string;
}
export interface IUpdateBee extends Partial<IBee> {
  deviceId: DeviceId;
}
/**
 * Metadata information for a BEE
 */
export interface BEEMetadata {
  [k: string]: any;
}
/**
 * The shape of the temperature object for the device config heating configuration
 *
 * This interface was referenced by `BEEConfiguration`'s JSON-Schema
 * via the `definition` "device_config_heating_temperature".
 */
export interface DeviceConfigHeatingTemperature {
  upper: number;
  lower: number;
}
/**
 * The shape of the heating object for the device config
 *
 * This interface was referenced by `BEEConfiguration`'s JSON-Schema
 * via the `definition` "device_config_heating".
 */
export interface DeviceConfigHeating {
  temperature: DeviceConfigHeatingTemperature;
  [k: string]: any;
}
/**
 * The shape of the temperature object for the device config hot water configuration
 *
 * This interface was referenced by `BEEConfiguration`'s JSON-Schema
 * via the `definition` "device_config_hot_water_temperature".
 */
export interface DeviceConfigHotWaterTemperature {
  /**
   * The on temperature
   */
  on: number;
  /**
   * The off temperature
   */
  off: number;
}
/**
 * @deprecated The shape of the temperature object for the device config
 *
 * This interface was referenced by `BEEConfiguration`'s JSON-Schema
 * via the `definition` "device_config_temperature".
 */
export interface DeviceConfigTemperature {
  upper: number;
  lower: number;
}
/**
 * Defines configuration to be used by the BEE for runtime operations
 *
 * This interface was referenced by `BEEConfiguration`'s JSON-Schema
 * via the `definition` "device_config".
 */
export interface DeviceConfig {
  /**
   * Specifies the location the device is in for timezone information
   */
  location: "Europe/London";
  heating?: DeviceConfigHeating;
  hot_water_temperature?: DeviceConfigHotWaterTemperature;
  temperature?: DeviceConfigTemperature;
}
/**
 * Defines the shape of a MBus device. Used to configure MBus devices on the BEE
 *
 * This interface was referenced by `BEEConfiguration`'s JSON-Schema
 * via the `definition` "mbus_device".
 */
export interface MBusDevice {
  name: string;
  protocol: "MBus";
}
/**
 * Defines the shape of a relay device. Used to configure relay devices on the BEE
 *
 * This interface was referenced by `BEEConfiguration`'s JSON-Schema
 * via the `definition` "relay_device".
 */
export interface RelayDevice {
  name: string;
  protocol: "gpio";
}
/* eslint-disable */
  /* tslint:disable */
/**
 * This file was automatically generated by json-schema-to-typescript.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
 * and run json-schema-to-typescript to regenerate this file.
 */

/**
 * Defines the shape of a Modbus device fields. Used to configure Modbus devices on the BEE
 *
 * This interface was referenced by `BEEConfiguration`'s JSON-Schema
 * via the `definition` "modbus_device_fields".
 */
export type ModbusDeviceFields = {
  name?: string;
  format?: "float" | "int" | "ascii" | "uint";
  factor?: number;
  unit?: string;
  access?: string;
  address?: string;
  length?: number;
  [k: string]: any;
}[];
/**
 * Defines the shape of a Modbus device. Used to configure Modbus devices on the BEE
 *
 * This interface was referenced by `BEEConfiguration`'s JSON-Schema
 * via the `definition` "modbus_device".
 */
export interface ModbusDevice {
  name: string;
  protocol: "ModbusRTU" | "ModbusTCP" | "internal";
  fields: ModbusDeviceFields;
}
/**
 * Defines the shape of a Mastertherm device fields. Used to configure Mastertherm devices on the BEE
 *
 * This interface was referenced by `BEEConfiguration`'s JSON-Schema
 * via the `definition` "mastertherm_device_fields".
 */
export type MasterthermDeviceFields = {
  name?: string;
  format?: "float" | "int" | "ascii";
  factor?: number;
  unit?: string;
  access?: string;
  address?: string;
  length?: number;
  [k: string]: any;
}[];
/**
 * Defines the shape of a Mastertherm device. Used to configure Mastertherm devices on the BEE
 *
 * This interface was referenced by `BEEConfiguration`'s JSON-Schema
 * via the `definition` "mastertherm_device".
 */
export interface MasterthermDevice {
  name: string;
  protocol: "ModbusTCP";
  fields: MasterthermDeviceFields;
}
/**
 * Defines the shape of a schedule. Used to run rules on the BEE. The name of a schedule should refer back to the name of a rule
 *
 * This interface was referenced by `BEEConfiguration`'s JSON-Schema
 * via the `definition` "schedule".
 */
export interface Schedule {
  name: string;
  schedule:
    | "once"
    | "second"
    | "second_2"
    | "second_5"
    | "second_15"
    | "second_30"
    | "minute"
    | "minute_5"
    | "minute_10"
    | "minute_15"
    | "minute_30"
    | "hour"
    | "disabled";
}
/**
 * The label for the circuit
 */
export type CircuitLabel = string;
/**
 * The circuit label for clamp 1
 */
export type CircuitLabelForClamp1 = string;
/**
 * The circuit label for clamp 2
 */
export type CircuitLabelForClamp2 = string;
/**
 * The circuit label for clamp 3
 */
export type CircuitLabelForClamp3 = string;
/**
 * A list of non-metered circuits
 */
export type NonMeteredCircuits = string;
/**
 * Specifies a unique identifier for multiple devices of the same type within a home
 *
 * This interface was referenced by `BEEConfiguration`'s JSON-Schema
 * via the `definition` "sensor_id".
 */
export type DeviceSensorId = string;
/**
 * Specifies the address of a device
 *
 * This interface was referenced by `BEEConfiguration`'s JSON-Schema
 * via the `definition` "address".
 */
export type DeviceAddress = string;
/**
 * Specifies the channel a device will communicate on
 *
 * This interface was referenced by `BEEConfiguration`'s JSON-Schema
 * via the `definition` "channel".
 */
export type DeviceChannel = string;
/**
 * Determines if the rule being setup is used as the primary zone temperature sensor
 *
 * This interface was referenced by `BEEConfiguration`'s JSON-Schema
 * via the `definition` "primary_zone_temperature_sensor".
 */
export type PrimaryZoneTemperatureSensor = string;
/**
 * The circuit type for clamp 1
 */
export type CircuitTypeForClamp1 = string;
/**
 * The circuit type for clamp 2
 */
export type CircuitTypeForClamp2 = string;
/**
 * The circuit type for clamp 3
 */
export type CircuitTypeForClamp3 = string;
/**
 * The circuit type for clamp 4
 */
export type CircuitTypeForClamp4 = string;
/**
 * The circuit type for clamp 5
 */
export type CircuitTypeForClamp5 = string;
/**
 * The circuit type for clamp 6
 */
export type CircuitTypeForClamp6 = string;
export type CalendarKey = 'sameDay' | 'nextDay' | 'lastDay' | 'nextWeek' | 'lastWeek' | 'sameElse' | string;
/* eslint-disable */
  /* tslint:disable */
/**
 * This file was automatically generated by json-schema-to-typescript.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
 * and run json-schema-to-typescript to regenerate this file.
 */

/**
 * Uptime represents how long a BEE has been online for
 */
export type Uptime = string;
/**
 * System Memory represents memory information and usage on the BEE
 */
export type SystemMemory = string;
/**
 * The version of the BEE. Represents an overall version of core and firmware
 */
export type AppVersion = string;
/**
 * The version of BEE core
 */
export type BEECore = string;
/**
 * The version of BEE firmware
 */
export type BEEFirmware = string;
/**
 * The unique ID of the BEE
 */
export type BoardID = string;
/**
 * The CPU scheduler usage
 */
export type CPUScheduler = string;
/**
 * The name of the disk
 */
export type TheNameOfTheDisk = string;
/**
 * The type of device
 */
export type DeviceTypePH = string;
/**
 * The failure reason for a healthcheck
 */
export type Reason = string | null;
/**
 * The time at which the healthcheck was run
 */
export type Timestamp = string;
/**
 * The zone ID relating to the peripheral being tested
 */
export type ZoneID = string;
/**
 * The MAC address of the router
 */
export type RouterMAC = string;
/**
 * The timestamp of the data when sent up to the cloud
 */
export type Timestamp1 = string;
/**
 * The method by which the action was set
 */
export type By = string;
/**
 * The time at which the action was set
 */
export type Time = string;
/** @public */
export declare type ExplainVerbosity = string;
export type SubFolder = 'rotate-keys' | 'state' | 'rc_stop' | 'rc_start' | 'upgrade' | string;
export declare type SignerGetSignedUrlResponse = string;
export type IUploaded = string;
export type KeyType = string;
export type NIL = string;
export type SQSMessageAttributeDataType = 'String' | 'Number' | 'Binary' | string;
/**
 * Meta schema
 *
 * Recommended values:
 * - 'http://json-schema.org/schema#'
 * - 'http://json-schema.org/hyper-schema#'
 * - 'http://json-schema.org/draft-04/schema#'
 * - 'http://json-schema.org/draft-04/hyper-schema#'
 * - 'http://json-schema.org/draft-03/schema#'
 * - 'http://json-schema.org/draft-03/hyper-schema#'
 *
 * @see https://tools.ietf.org/html/draft-handrews-json-schema-validation-01#section-5
 */
export type JSONSchema4Version = string;
/**
 * Meta schema
 *
 * Recommended values:
 * - 'http://json-schema.org/schema#'
 * - 'http://json-schema.org/hyper-schema#'
 * - 'http://json-schema.org/draft-06/schema#'
 * - 'http://json-schema.org/draft-06/hyper-schema#'
 *
 * @see https://tools.ietf.org/html/draft-handrews-json-schema-validation-01#section-5
 */
export type JSONSchema6Version = string;
/**
 * Meta schema
 *
 * Recommended values:
 * - 'http://json-schema.org/schema#'
 * - 'http://json-schema.org/hyper-schema#'
 * - 'http://json-schema.org/draft-07/schema#'
 * - 'http://json-schema.org/draft-07/hyper-schema#'
 *
 * @see https://tools.ietf.org/html/draft-handrews-json-schema-validation-01#section-5
 */
export type JSONSchema7Version = string;
/**
 * The position of the dip switch
 */
export type DipSwitchPosition = string | number;
/**
 * The amperage of the meter
 */
export type MeterAmperage = string | number;
/**
 * The CPU temperature
 */
export type CPUTemp = number | string;
/**
 * The shape of the metadata object for device rules configuration
 *
 * This interface was referenced by `BEEConfiguration`'s JSON-Schema
 * via the `definition` "rule_metadata".
 */
export interface DeviceRulesMetadata {
  heating_system?: HeatingSystem;
  circuit_label?: CircuitLabel;
  clamp_1_circuit_label?: CircuitLabelForClamp1;
  clamp_2_circuit_label?: CircuitLabelForClamp2;
  clamp_3_circuit_label?: CircuitLabelForClamp3;
  non_metered_circuits?: NonMeteredCircuits;
  install_location?: PhysicalLocationID;
  dip_switch_position?: DipSwitchPosition;
  meter_amperage?: MeterAmperage;
  category?: RuleCategory;
  heat_flow_meter_circuit?: HeatFlowMeterCircuit;
  action_type?: RuleActionType;
  variant?: RuleVariant;
  heat_pump_heating_control?: HeatPumpHeatingControl;
}
/**
 * Describes the shape of a channel for a TCP connection
 *
 * This interface was referenced by `BEEConfiguration`'s JSON-Schema
 * via the `definition` "channel_tcp".
 */
export interface DeviceChannelForTCPConnections {
  address?: string;
  port?: number;
  [k: string]: any;
}
/**
 * The shape of the metadata object for device rules input configuration
 *
 * This interface was referenced by `BEEConfiguration`'s JSON-Schema
 * via the `definition` "rule_input_metadata".
 */
export interface DeviceRulesInputMetadata {
  circuit_type?: CircuitType;
  clamp_1_circuit_type?: CircuitTypeForClamp1;
  clamp_2_circuit_type?: CircuitTypeForClamp2;
  clamp_3_circuit_type?: CircuitTypeForClamp3;
  clamp_4_circuit_type?: CircuitTypeForClamp4;
  clamp_5_circuit_type?: CircuitTypeForClamp5;
  clamp_6_circuit_type?: CircuitTypeForClamp6;
}
/**
 * This interface was referenced by `BEEConfiguration`'s JSON-Schema
 * via the `definition` "rule_inputs".
 */
export interface DeviceRulesInputs {
  device_type?: DeviceType;
  zone_id?: HeatingZoneID;
  sensor_id?: DeviceSensorId;
  address?: DeviceAddress;
  channel?: DeviceChannel | DeviceChannelForTCPConnections;
  primary_zone_temperature_sensor?: PrimaryZoneTemperatureSensor;
  hot_water_source_type?: HotWaterSourceType;
  metadata?: DeviceRulesInputMetadata;
  [k: string]: any;
}
/**
 * Defines the shape of a rule. A rule is made up of queries, conditions, inputs, name, description and metadata
 *
 * This interface was referenced by `BEEConfiguration`'s JSON-Schema
 * via the `definition` "rule".
 */
export interface Rule {
  name: string;
  description: string;
  metadata?: DeviceRulesMetadata;
  inputs: DeviceRulesInputs;
  queries:
    | []
    | [
        {
          name: string;
          device_name?: string;
          type: "system_state" | "system_zone_state" | "system_device_config_state" | "device";
          attributes: [] | [string, ...any[]];
        },
        ...any[]
      ];
  conditions: {
    type: "run_actions" | "if" | "and" | "or" | "if_end";
    condition?: {
      [k: string]: any;
    };
    actions: {
      type:
        | "mqtt_publish"
        | "set_persisted_system_state"
        | "set_non_persisted_system_state"
        | "set_persisted_zone_state"
        | "set_non_persisted_zone_state"
        | "set_zone_wrf06_state"
        | "set_input"
        | "set_relay"
        | "set_relay_with_hysteresis"
        | "set_device"
        | "debug"
        | "schedule"
        | "run_rule"
        | "run_heating_schedule"
        | "run_hot_water_schedule"
        | "cancel_hot_water_override"
        | "cancel_device_off";
      params: {
        [k: string]: any;
      };
    }[];
  }[];
}
/**
 * Defines the shape of a heating schedule. A heating schedule is made up of 7 days (Monday - Sunday) with a maximum of 6 setpoints for each day
 *
 * This interface was referenced by `BEEConfiguration`'s JSON-Schema
 * via the `definition` "heating_schedule".
 */
export interface HeatingSchedule {
  zone_id: HeatingZoneID;
  setpoints: HeatingScheduleSetpoint[];
  [k: string]: any;
}
/**
 * Defines heating zones available to a BEE
 *
 * This interface was referenced by `BEEConfiguration`'s JSON-Schema
 * via the `definition` "heating_zone".
 */
export interface HeatingZone {
  zone_id: HeatingZoneID;
  /**
   * Specifies the description of the heating zone
   */
  description?: string;
}
/**
 * A hot water schedule for each day of the week and times to start heating water and stop heating water
 */
export interface HotWaterSchedules {
  monday?: HotWaterSchedule[];
  tuesday?: HotWaterSchedule[];
  wednesday?: HotWaterSchedule[];
  thursday?: HotWaterSchedule[];
  friday?: HotWaterSchedule[];
  saturday?: HotWaterSchedule[];
  sunday?: HotWaterSchedule[];
}
export interface BEEConfiguration {
  metadata?: BEEMetadata;
  /**
   * Defines the version of the current schema config. Used by the BEE to determine if it has changed
   */
  schema_version: "2.0.0" | "2.3.0";
  /**
   * Defines the version of the current rules config. Used by the BEE to determine if it has changed
   */
  rules_version?: string;
  /**
   * Defines the version of the current schedules config. Used by the BEE to determine if it has changed
   */
  schedules_version?: string;
  /**
   * Defines the version of the current devices config. Used by the BEE to determine if it has changed
   */
  devices_version?: string;
  /**
   * Defines the version of the user heating schedules config. Used by the BEE to determine if it has changed
   */
  heating_schedules_version?: string;
  /**
   * Defines the version of the user hot water schedules config. Used by the BEE to determine if it has changed
   */
  hot_water_schedules_version?: string;
  /**
   * @deprecated Defines the version of the user heating zones config. Used by the BEE to determine if it has changed
   */
  heating_zones_version?: string;
  device_config: DeviceConfig;
  /**
   * A list of peripheral devices that are supported by the BEE and contain configuration for rules to understand how to retrieve data from a specific device
   */
  devices: (MBusDevice | RelayDevice | ModbusDevice | MasterthermDevice)[];
  /**
   * A list of schedules to be run by the BEE for specific rules. The name property must refer back to a rule name
   */
  schedules: Schedule[];
  /**
   * A list of rules that should be run by the BEE to monitor or perform control
   */
  rules: Rule[];
  /**
   * A list of heating schedules to be run by the BEE. A maximum of 7 days can be defined here
   */
  heating_schedules: {
    monday?: HeatingSchedule[];
    tuesday?: HeatingSchedule[];
    wednesday?: HeatingSchedule[];
    thursday?: HeatingSchedule[];
    friday?: HeatingSchedule[];
    saturday?: HeatingSchedule[];
    sunday?: HeatingSchedule[];
  };
  /**
   * @deprecated A list of heating zones available to the BEE
   */
  heating_zones?: HeatingZone[];
  hot_water_schedules?: HotWaterSchedules;
  /**
   * A list of settings for the BEE
   */
  settings?: {
    /**
     * The intervals in which the state events are run at.
     */
    state_tx_interval_mins?: number;
    [k: string]: any;
  };
}
/**
 * The status of the healthcheck
 */
export type Status = "passed_healthcheck" | "failed_healthcheck";
/**
 * Describes the shape of a peripheral healthcheck
 *
 * This interface was referenced by `BEEStateSchema`'s JSON-Schema
 * via the `definition` "peripheral_healthcheck".
 */
export interface PeripheralHealthcheck {
  device_type?: DeviceTypePH;
  reason?: Reason;
  status?: Status;
  timestamp?: Timestamp;
  zone_id?: ZoneID;
  [k: string]: any;
}
/**
 * The healthchecks of the peripherals attached to, and being used by the BEE
 */
export type PeripheralHealthchecks = {
  wrf04?: PeripheralHealthcheck[];
  wrf06?: PeripheralHealthcheck[];
  iem3100?: PeripheralHealthcheck[];
  additionalProperties?: false;
  [k: string]: any;
} | null;
export interface IBeeInfo {
  status: BeeStatus;
  currentAppVersion?: string;
  latestAppVersion?: string;
  hardwareVersion?: string;
  bee?: IBee;
  config?: BEEConfiguration;
  arePeripheralsHealthy?: boolean;
  peripheralHealthChecks?: PeripheralHealthchecks[];
  firmwareUpdateRequested?: string;
  currentFirmwareVersion?: string;
  lastStatusUpdate?: string;
  isHealthy?: boolean;
  stateLastUpdated?: string;
  uptime?: string;
}
export type SearchBeeDataResponse = IBeeInfo;
export interface IRemove {
  deviceId: DeviceId;
}
export enum ModbusAddresses45AmpMeter {
  A5 = 5,
  A7 = 7,
  A9 = 9,
  A11 = 11,
}
export type InlineMeterIem2055 = InlineMeter<DeviceType.IEM2055, Amperage.inlineMeter45amp, ModbusAddresses45AmpMeter>;
export enum ModbusAddresses63AmpMeter {
  A6 = 6,
  A8 = 8,
  A10 = 10,
  A12 = 12,
}
export type InlineMeterIem2155 = InlineMeter<DeviceType.IEM2155, Amperage.inlineMeter63amp, ModbusAddresses63AmpMeter>;
export type CTMeterIem3100 = CTMeter<DeviceType.IEM3100>;
export type CTMeter_SCHNEIDER_IEM3455 = CTMeter<DeviceType.SCHNEIDER_IEM3455>;
export type CTMeter_EASTRON_SDM630MCT_4L = CTMeter<DeviceType.EASTRON_SDM630MCT_4L>;
export type CTMeter_EASTRON_SDM630MCT_MV = CTMeter<DeviceType.EASTRON_SDM630MCT_MV>;
export type HeatFlowMeterSharky = HeatFlowMeter<DeviceType.SHARKY>;
export type RoomSensorWrf04 = RoomSensor<DeviceType.WRF04>;
export type RoomSensorMastertherm = RoomSensor<DeviceType.MASTERTHERM>;
export type HeatingControlRelay = HeatingControl<DeviceType.RELAY>;
export type HeatingControlHeatPump = HeatingControl<DeviceType.MASTERTHERM>;
export type RoomDialWrf06 = RoomDial<DeviceType.WRF06>;
export type RoomSensorWrf06 = RoomSensor<DeviceType.WRF06>;
export type HotWaterSourceRelay = HotWaterSourceInput<DeviceType.RELAY>;
export type HotWaterSourceMasterTherm = HotWaterSourceInput<DeviceType.MASTERTHERM>;
export type RoomSensorRegin = RoomSensor<DeviceType.REGIN>;
export type RoomSensorNovos3 = RoomSensor<DeviceType.NOVOS3>;
export type TemperatureSensorNtctf25 = TemperatureSensor<DeviceType.NTCTF25>;
export type DeviceInfo =
  | InlineMeterIem2055
  | InlineMeterIem2155
  | CTMeterIem3100
  | CTMeter_SCHNEIDER_IEM3455
  | CTMeter_EASTRON_SDM630MCT_4L
  | CTMeter_EASTRON_SDM630MCT_MV
  | HeatFlowMeterSharky
  | RoomSensorWrf04
  | RoomSensorMastertherm
  | HeatingControlRelay
  | HeatingControlHeatPump
  | RoomDialWrf06
  | RoomSensorWrf06
  | HotWaterSourceRelay
  | HotWaterSourceMasterTherm
  | RoomSensorRegin
  | RoomSensorNovos3
  | TemperatureSensorNtctf25;
/**
 * Alarms represent activity on the BEE
 */
export interface Alarms {
  [k: string]: any;
}
/**
 * Load average represents the average load a BEE is under
 */
export type LoadAverage = string | (number | string)[];
/**
 * The disk usage of the BEE as key value pairs
 */
export interface DiskUsage {
  /**
   * This interface was referenced by `DiskUsage`'s JSON-Schema definition
   * via the `patternProperty` ".*".
   *
   * This interface was referenced by `DiskUsageKVPs`'s JSON-Schema definition
   * via the `patternProperty` ".*".
   */
  [k: string]: string | number;
}
export type IFileOptionsOptimizeMode = number;
export type IFieldDescriptorProtoLabel = number;
export type IFieldDescriptorProtoType = number;
export type IFieldOptionsJSType = number;
/**
 * Some information relating to this disk
 */
export type SomeInformationRelatingToThisDisk = number;
/**
 * The temperature of the zone
 */
export type Temperature = number;
/**
 * The number of bytes in the MQTT cache
 */
export type MQTTCacheBytes = number;
/**
 * The number of messages in the cache
 */
export type MQTTCached = number;
/**
 * Describes the shape of a disk usage item
 *
 * This interface was referenced by `BEEStateSchema`'s JSON-Schema
 * via the `definition` "disk_usage_items".
 */
export interface DiskUsageItems {
  name: TheNameOfTheDisk;
  used: SomeInformationRelatingToThisDisk;
  [k: string]: any;
}
/**
 * The disk usage of the BEE as an array of key value pairs
 */
export type DiskUsage1 = DiskUsageItems[] | string;
/**
 * The time at which an action was set for a zone
 */
export interface SetAt {
  by: By;
  time: Time;
  [k: string]: any;
}
/**
 * Describes the shape of a information relating back to a zone
 *
 * This interface was referenced by `BEEStateSchema`'s JSON-Schema
 * via the `definition` "zone_information".
 */
export interface ZoneInformation1 {
  set_at?: SetAt;
  temperature?: Temperature;
  [k: string]: any;
}
/**
 * Information relating back to a zone
 */
export type ZoneInformation = {
  ground_floor?: ZoneInformation1;
  first_floor?: ZoneInformation1;
  second_floor?: ZoneInformation1;
  third_floor?: ZoneInformation1;
  living_room?: ZoneInformation1;
  bedroom_1?: ZoneInformation1;
  bedroom_2?: ZoneInformation1;
  bathroom?: ZoneInformation1;
  [k: string]: any;
} | null;
/**
 * The on/off of peripherals within a home
 */
export type UnitOnOff =
  | null
  | {
      [k: string]: any;
    }
  | any[];
/**
 * @deprecated Indicates if the disk is almost full
 */
export type DiskAlmostFull = string | boolean;
/**
 * @deprecated The high watermark of system memory
 */
export type SystemMemoryHighWatermark = string | boolean;
/**
 * For backwards compatibility, true is interpreted as "allPlansExecution"
 * and false as "queryPlanner". Prior to server version 3.6, aggregate()
 * ignores the verbosity parameter and executes in "queryPlanner".
 * @public
 */
export declare type ExplainVerbosityLike = ExplainVerbosity | boolean;
export interface BEEStateSchema {
  alarms?: Alarms;
  uptime?: Uptime;
  load_average?: LoadAverage;
  system_memory?: SystemMemory;
  app_version?: AppVersion;
  bee_core?: BEECore;
  bee_firmware?: BEEFirmware;
  bee_hardware?: BEEHardware;
  board_id?: BoardID;
  cpu_scheduler?: CPUScheduler;
  cpu_temp?: CPUTemp;
  disk_usage?: DiskUsage | DiskUsage1;
  peripheral_healthchecks?: PeripheralHealthchecks;
  router_mac?: RouterMAC;
  timestamp?: Timestamp1;
  zones?: ZoneInformation;
  unit_on_off?: UnitOnOff;
  disk_almost_full?: DiskAlmostFull;
  system_memory_high_watermark?: SystemMemoryHighWatermark;
  mqtt_cache_bytes?: MQTTCacheBytes;
  mqtt_cached?: MQTTCached;
}
export interface IAuth0Organisation {
  display_name: string;
  id: string;
  name: string;
}

export interface HeaderMap {
  [k: string]: string
}

export interface IFetcher {
  request<T>(url: string, verb: string, contentType: string, body?: any, headers?: HeaderMap): Promise<T>
  buildQueryString(query?: any): string
  requestValidate?(routeUniqueName: string, paramValues: {body?:any, params?: any, query?: any}) : Promise<void>
}

export class Qs {
  private static buildQueryStringKeyValueItem(key: string, value: any): string {
    return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
  }

  static buildQueryStringKeyValue(key: string, value: any): string {
    if (Array.isArray(value)) {
      return value.map(v => Qs.buildQueryStringKeyValueItem(key, v)).join('&');
    }
    return Qs.buildQueryStringKeyValueItem(key, value);
  }

  static buildQueryString(query?: any, buildQueryStringValue?: (key: string, value: any) => string): string {
    if (!query) {
      return '';
    }
    const fn = buildQueryStringValue || Qs.buildQueryStringKeyValue;
    const keys = Object.keys(query).filter(k => !!query[k]);
    const qs = keys.map(k => fn(k, query[k])).join('&');
    if (qs) {
      return `?${qs}`;
    }
    return '';
  }
}

export function optionalParam(parameter: any, key: string) {
  return parameter && parameter[key] ? `/${parameter[key]}` : ""
}


export class BeeController {
  constructor(private fetcher: IFetcher){}

  register = async (body: IRegister, headers?: HeaderMap): Promise<void> => {
    return await this.fetcher.request<void>(`/bee/register`, "post", "application/json", body, headers)
  }

  commission = async (body: ICommission, headers?: HeaderMap): Promise<void> => {
    return await this.fetcher.request<void>(`/bee/commission`, "post", "application/json", body, headers)
  }

  update = async (body: IUpdateBee, headers?: HeaderMap): Promise<IBeeInfo> => {
    return await this.fetcher.request<IBeeInfo>(`/bee`, "put", "application/json", body, headers)
  }

  list = async (headers?: HeaderMap): Promise<IBee[]> => {
    return await this.fetcher.request<IBee[]>(`/bee`, "get", "application/json", undefined, headers)
  }

  remove = async (body: IRemove, headers?: HeaderMap): Promise<void> => {
    return await this.fetcher.request<void>(`/bee/remove`, "delete", "application/json", body, headers)
  }
}
export class ConfigController {
  constructor(private fetcher: IFetcher){}

  updateDeviceRules = async (body: { deviceId: DeviceId; devices: DeviceInfo[] }, headers?: HeaderMap): Promise<BEEConfiguration> => {
    return await this.fetcher.request<BEEConfiguration>(`/config/devices-rules`, "post", "application/json", body, headers)
  }

  replaceConfig = async (body: {
        deviceId: DeviceId;
        data: BEEConfiguration;
        fileName?: string;
        alterScheduleFrequency?: boolean;
      }, headers?: HeaderMap): Promise<BEEConfiguration> => {
    return await this.fetcher.request<BEEConfiguration>(`/config/replace`, "post", "application/json", body, headers)
  }

  findConfig = async (query?: { deviceId?: DeviceId; routerId?: RouterId }, headers?: HeaderMap): Promise<BEEConfiguration> => {
    return await this.fetcher.request<BEEConfiguration>(`/config${this.fetcher.buildQueryString(query)}`, "get", "application/json", undefined, headers)
  }
}
export class EquinoxController {
  constructor(private fetcher: IFetcher){}

  startEvent = async (body: string, headers?: HeaderMap): Promise<boolean> => {
    return await this.fetcher.request<boolean>(`/equinox/dispatch/start`, "put", "application/json", body, headers)
  }

  stopEvent = async (body: string, headers?: HeaderMap): Promise<boolean> => {
    return await this.fetcher.request<boolean>(`/equinox/dispatch/stop`, "put", "application/json", body, headers)
  }
}
export class StateController {
  constructor(private fetcher: IFetcher){}

  getStateByDeviceId = async (params: { deviceId: DeviceId }, headers?: HeaderMap): Promise<BEEStateSchema> => {
    return await this.fetcher.request<BEEStateSchema>(`/state/${params.deviceId}`, "get", "application/json", undefined, headers)
  }
}
export class StorageController {
  constructor(private fetcher: IFetcher){}

  uploadFile = async (body: any, headers?: HeaderMap): Promise<IUploaded> => {
    return await this.fetcher.request<IUploaded>(`/storage/upload`, "post", "multipart/form-data", body, headers)
  }

  downloadFile = async (params: { fileName: string }, headers?: HeaderMap): Promise<any> => {
    return await this.fetcher.request<any>(`/storage/${params.fileName}`, "get", "application/octet-stream", undefined, headers)
  }
}
export class ApiClient {
  constructor(private fetcher: IFetcher){}

  bee = new BeeController(this.fetcher)
  
  config = new ConfigController(this.fetcher)
  
  equinox = new EquinoxController(this.fetcher)
  
  state = new StateController(this.fetcher)
  
  storage = new StorageController(this.fetcher)
  
}
